import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.CIsX-mt9.js","_app/immutable/chunks/disclose-version.DZaQXHkE.js","_app/immutable/chunks/runtime.CkDI4bGX.js","_app/immutable/chunks/legacy.CMQtmpCj.js","_app/immutable/chunks/lifecycle.PEt4dGlZ.js","_app/immutable/chunks/props.B-AjMruD.js","_app/immutable/chunks/Loading.CMeIEj-n.js","_app/immutable/chunks/render.BHL7ctEy.js","_app/immutable/chunks/slot.CZzdtJAX.js","_app/immutable/chunks/index-client.i0OL8c_P.js","_app/immutable/chunks/entry.CsaccjV-.js"];
export const stylesheets = ["_app/immutable/assets/2.I-YOC0Je.css","_app/immutable/assets/Loading.2QRZDmh7.css"];
export const fonts = [];
